module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "cvia"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_cvi_r1.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "tpa"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_tp_r1.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "deda"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_ded_r1.htm"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c01a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c01_r1.htm"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c02a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c02_r1.htm"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c03a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c03_r1.htm"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c04a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c04_r1.htm"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c05a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c05_r1.htm"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c06a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c06_r1.htm"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c07a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c07_r1.htm"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c08a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c08_r1.htm"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c09a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c09_r1.htm"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c10a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c10_r1.htm"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c11a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c11_r1.htm"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c12a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c12_r1.htm"
    }
  }, [_vm._v("CHAPTER TWELE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c13a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c13_r1.htm"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c14a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c14_r1.htm"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c15a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c15_r1.htm"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c16a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c16_r1.htm"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c17a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c17_r1.htm"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c18a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c18_r1.htm"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c19a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c19_r1.htm"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c20a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c20_r1.htm"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c21a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_c21_r1.htm"
    }
  }, [_vm._v("CHAPTER TWENTY ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "acka"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_ack_r1.htm"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ataa"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_ata_r1.htm"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "otba"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_otb_r1.htm"
    }
  }, [_vm._v("Other Books by Edna Buchanan")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "fm1a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_fm1_r1.htm"
    }
  }, [_vm._v("Resounding praise for EDNA BUCHANAN and "), _c('em', [_vm._v("PULSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "copa"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_cop_r1.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "atpa"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780061957710_epub_atp_r1.htm"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21168372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780061957710_epub_toc_r1.vue
// module id = 66
// module chunks = 0